import React, { useEffect, useRef, useState } from 'react'

import clsx from 'clsx'

import CompareBasket from 'components/CompareBasket'
import Icon from 'components/Icon'
import { useCompareBasket } from 'context/CompareBasketContext'
import { useEventContext } from 'context/EventContext'
import useOutsideClick from 'hooks/useOutsideClick'

import classes from './CompareBasket.module.scss'

/** @type {import("./types").default} */
const AppBarCompareBasket = ({ variant = 'dark' }) => {
  const compareBasketRef = useRef()
  const [showCompareBasket, setShowCompareBasket] = useState(false)
  const [dialogOpen, setDialogOpen] = useState(false)
  const compareBasket = useCompareBasket()
  const { sendEvent } = useEventContext()
  const shouldRender = useRef(false)

  const hideBasket = () => {
    setShowCompareBasket(false)
  }

  useOutsideClick(compareBasketRef, dialogOpen ? () => {} : hideBasket)

  useEffect(() => {
    if (!shouldRender.current) {
      shouldRender.current = true
      return
    }
    if (!showCompareBasket && compareBasket.items.length) {
      setShowCompareBasket(true)
    }
    // Dont add setShowCompareBasket as a dependency because it breaks the
    // behaviour for when the user clicks outside of the compare basket modal
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [compareBasket.items.length])

  if (!compareBasket.isEnabled) {
    return null
  }

  return (
    <div className="CompareBasket" ref={compareBasketRef}>
      <div
        role="presentation"
        data-testid="appbar_compare-basket_button"
        onClick={() => {
          setShowCompareBasket(show => {
            if (!show) {
              sendEvent({
                engagementComponent: 'compare-basket',
                engagementDestination: 'open-compare-basket',
                engagementDetails: 'button_compare-basket',
                name: 'engagement_compare_tray',
              })
            }
            return !show
          })
        }}
        className={clsx(classes.root, {
          [classes.active]: showCompareBasket,
          [classes.dark]: variant === 'dark',
          [classes.light]: variant === 'light',
          [classes.nonEmpty]: compareBasket.items.length,
        })}
      >
        <Icon size={24} icon={['ga', 'compare']} className={classes.icon} />
        <span>{compareBasket.items.length}</span>
      </div>
      <div className={clsx(classes.basket, { [classes.show]: showCompareBasket })}>
        <CompareBasket dialogOpen={dialogOpen} setDialogOpen={setDialogOpen} />
      </div>
    </div>
  )
}

export default AppBarCompareBasket
